import { IGroup } from "../../data/models/Entities";
import { MProximidadTutorItem } from "../../data/models/MProximidadItem";
import { _SvProximidadObtenerTutoresEnCamino } from "../../data/services/Proximidad";
import { ProximidadPopoverContent, TProximGroupID } from '../../features/proximidad/components/ProximidadPopoverContent/ProximidadPopoverContent';
import "../components-lit/Popover/Popover";
import { AppPopoverComponent } from "../components-lit/Popover/Popover";


const POLLING_TIME_MS = 4 * 60 * 1000; // 4 minutos

export class ProximidadController {
    private static instance: ProximidadController;
    private static popover: AppPopoverComponent;
    private static popoverContent: ProximidadPopoverContent;

    private pollingInterval: NodeJS.Timeout | null;

    private _refElement: HTMLElement | string | null = null;
    private popover: AppPopoverComponent | null = null;
    private popoverContent: ProximidadPopoverContent | null = null;

    /** Map<IdEscuela, FechaMaxima> */
    private lastIDData: Map<number, string> = new Map<number, string>();
    public requireBadge = false;

    public onLoadDataCallback: (() => void) | null = null;

    constructor() {
        if (ProximidadController.instance) {
            ProximidadController.popoverContent.setConsultDelegate = this.fetchData.bind(this);
            this.popover = ProximidadController.popover;
            this.popoverContent = ProximidadController.popoverContent;
            return ProximidadController.instance;
        }
        ProximidadController.instance = this;
        ProximidadController.popover = new AppPopoverComponent();
        ProximidadController.popover.placement = "bottom";
        ProximidadController.popoverContent = new ProximidadPopoverContent();
        ProximidadController.popoverContent.parentPopover = ProximidadController.popover;

        this.pollingInterval = null;
        this.popover = ProximidadController.popover;
        this.popoverContent = ProximidadController.popoverContent;

        ProximidadController.popoverContent.setConsultDelegate = this.fetchData.bind(this);
        this.popover.classList.add('app-proximity-popover');
        this.popover.appendChild(ProximidadController.popoverContent);

        this.refreshPopoverHeight();
    }

    public _SetGroups(groups: IGroup[], selectedGroup?: IGroup[]): void {
        this.popoverContent.availableGroups = groups;
        if (selectedGroup !== undefined) {
            this.popoverContent.selectedGroup = selectedGroup || [];
        }
    }

    public _SetSelectedGroup(groups: TProximGroupID[]): void {
        this.popoverContent.selectedGroup = groups || [];
    }

    public _AddSelectedGroup(group: TProximGroupID): void {
        this.popoverContent.addSelectedGroup(group);
    }

    public _IsGroupSelected(group: TProximGroupID): boolean {
        return this.popoverContent.isGroupSelected(group);
    }

    public _SetRefElement(refElement: HTMLElement | string) {
        this.defineRefElement(refElement);
    }

    public _OpenModal(refElement?: HTMLElement | string) {
        if (!refElement && this._refElement instanceof HTMLElement && this._refElement.isConnected) {
            refElement = this._refElement;
        }
        this.defineRefElement(refElement);

        if (!ProximidadController.popover || !this._refElement) return;
        this.popover.show(this._refElement);
        this.popoverContent.requestUpdate();
    }

    public _ToggleModal(refElement?: HTMLElement | string) {
        this.defineRefElement(refElement);

        if (!ProximidadController.popover || !this._refElement) return;
        this.popover.toggle(this._refElement);
        if (this.popover.open) {
            this.popoverContent.syncData();
        }
    }

    public _StartPolling(openOnResult = false, especificGroupIdsOnStart?: number[]) {
        if (this.pollingInterval) {
            // console.warn("Polling ya está activo.");
            return;
        }
        // console.log("Iniciando polling de proximidad...");
        this.popoverContent.syncData(especificGroupIdsOnStart).then(() => {
            if (openOnResult && this.popoverContent.groupedData.size > 0) {
                this._OpenModal();
            }
        });

        this.pollingInterval = setInterval(() => {
            this.popoverContent.syncData();
        }, POLLING_TIME_MS);
    }

    public _StopPolling() {
        if (this.pollingInterval) {
            // console.log("Deteniendo polling de proximidad...");
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    public _Destroy() {
        // console.log("Destruyendo controlador de proximidad...");
        this.onLoadDataCallback = null;
        this._StopPolling();
        if (this.popover) {
            this.popover.remove();
        }
    }

    /** Método para forzar la consulta. Ej.: desde una señal nativa */
    public _ForceConsult(openOnResult = false, consultIdsGroupIfSelected?: number[]) {
        // Hacer match con los grupos seleccionados en el popover, si es que hay alguno
        let selectedGroupIdsToConsult: number[];
        if (consultIdsGroupIfSelected && consultIdsGroupIfSelected.length > 0) {
            selectedGroupIdsToConsult = this.popoverContent.getResolvedSelectedGroups()
                .filter(g => consultIdsGroupIfSelected.includes(g.IdGrupo))
                .map(g => g.IdGrupo);

            if (selectedGroupIdsToConsult.length === 0) {
                selectedGroupIdsToConsult = undefined;
            }
        }

        // console.log("Forzando consulta de proximidad...");
        this._StopPolling();
        this._StartPolling(openOnResult, selectedGroupIdsToConsult); // restart
    }

    public _RefreshUI() {
        this.popoverContent.requestUpdate();
    }

    // PRIVATE METHODS

    private refreshPopoverHeight() {
        this.popover.style.height = `${this.popoverContent?.aproximateHeight}px`;
    }

    private defineRefElement(refElement: HTMLElement | string) {
        const refE = typeof refElement == "string" ? document.querySelector(refElement) : refElement;
        const refCurrent = typeof this._refElement == "string" ? document.querySelector(this._refElement) : this._refElement;

        if (refE?.isConnected) {
            if (refCurrent !== refE && refCurrent?.classList.contains("proximidad-popover-ref")) {
                refCurrent.remove();
            }
            this._refElement = refE as HTMLElement;
        } else {
            let floatingRef = document.querySelector(".proximidad-popover-ref") as HTMLElement | null;
            if (!floatingRef) {
                floatingRef = document.createElement("div");
                floatingRef.classList.add("proximidad-popover-ref");
                floatingRef.style.position = "fixed";
                floatingRef.style.top = "55px";
                floatingRef.style.left = "50%";
                floatingRef.style.transform = "translateX(-50%)";
                floatingRef.style.width = "0px";
                floatingRef.style.height = "0px";
                document.body.appendChild(floatingRef);
            }
            this._refElement = floatingRef;
        }
        return this._refElement;
    }

    private fetchData(idGrupo: number, idEscuela: number): Promise<MProximidadTutorItem[]> {
        if (!idGrupo) {
            return Promise.resolve([]);
        }
        return _SvProximidadObtenerTutoresEnCamino(idGrupo, idEscuela)
            .then((data: MProximidadTutorItem[]) => {
                // >> Actualizar requireBadge según la nueva data y la última fecha conocida
                if ((!data || data.length === 0) || this.popover.open) {
                    this.requireBadge = false;// Si no hay datos o el popover está abierto, no se requiere badge
                } else {
                    const idGrupo = data[0].IdGrupo;
                    const currentMaxima = data
                        .reduce((max, item) => {
                            const itemDate = new Date(item.FechaPosicion);
                            return itemDate > max ? itemDate : max;
                        }, new Date(0));
                    const lastMaxima = this.lastIDData.get(idGrupo);

                    // TESTING
                    this.requireBadge = !lastMaxima || currentMaxima.getTime() > new Date(lastMaxima).getTime();

                    this.lastIDData.set(idGrupo, currentMaxima.toISOString());
                }

                // >> Actualizar la data y notificar a la UI
                // this.data = data;
                if (this.onLoadDataCallback) {
                    this.onLoadDataCallback();
                }

                setTimeout(() => {
                    this.refreshPopoverHeight();
                });

                return data;
            })
            .catch((error) => {
                console.error("Error fetching proximity data:", error);
                return [];
            });
    }
}

export const _PROXIMIDAD_CTRL = new ProximidadController();